import { AwardRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateAward: (
  fetchContext: FetchContext,
  awardId: number,
  award: AwardRequest,
  accessToken?: string,
) => Promise<void> = async (fetchContext, awardId, award, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/awards/${awardId}`,
  {
    method: 'PUT',
    body: JSON.stringify(award),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update award'));
